<template>
  <button
    class="button primary asblock edit-availability-button"
    data-test="availability-link"
    @click="$emit('click')"
  >
    <translate>Check availability</translate>
  </button>
</template>

<script lang="ts">
import { Component, Vue, toNative } from '~/utility/pu-class-decorator'

@Component({
  emits: ['click'],
})
class PitchtypeEditAvailabilitySearchButton extends Vue {}

export default toNative(PitchtypeEditAvailabilitySearchButton)
</script>
